export default __webpack_public_path__ + "media/images/question-mark-82a2a3b74ed1e925f725167fd23cf643.png";